import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	stroke: "none",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#357DED",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0.0555563 7.2804H10.6639L6.02052 11.9237L6.55153 12.4548L12.1035 6.90279L6.55153 1.35083L6.02052 1.88184L10.6639 6.52519H0.0555563V7.2804Z" })
});
export default SvgArrow;
